export default __webpack_public_path__ + "static/media/Work Visa.0746c3c7.jpg";